<template>
  <div class="p-12-0 p-0-16 bg-FFFFFF fb fb-main-between fb-cross-center">
    <div @click="handlerToSelectTime(0)">
      <div class="font-30 c-191F25-40">开始时间</div>
      <div class="font-36 c-2F3135 mt-6 ff-medium text-bold-500">{{
        startTime.replace(/-/gi, '.')
      }}</div>
    </div>
    <div class="fb fb-cross-center fb-main-center">
      <i class="iconfont c-191F25-28 font-100">&#xe60c;</i>
    </div>
    <div @click="handlerToSelectTime(1)">
      <div class="font-30 c-191F25-40">结束时间</div>
      <div class="font-36 c-2F3135 mt-6 ff-medium text-bold-500">{{
        endTime.replace(/-/gi, '.')
      }}</div>
    </div>
  </div>
</template>

<script>
import { mcDatePicker, mcToast } from '@/utils/mcSdkUtils'
import { timeFormat } from '@/utils/comUtils'
export default {
  components: {},
  props: {
    crossType: {
      type: String,
      default: '' // day month
    },
    passby: {
      // 是否只能取过去时间
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeFormat: timeFormat,
      startTime: (() => {
        let time = timeFormat(new Date(), 'YYYY-MM-DD')
        switch (this.crossType) {
          case 'month':
            time = timeFormat(
              new Date(new Date().getTime() - 2592000000), // 30 * 86400000
              'YYYY-MM-DD'
            )
            break
          case 'day':
            time = timeFormat(new Date(), 'YYYY-MM-DD')
            break
          default:
            break
        }
        return time
      })(),
      endTime: timeFormat(new Date(), 'YYYY-MM-DD')
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.$emit('time-section', this.startTime, this.endTime)
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerToSelectTime(index) {
      let _defaultTime = index === 0 ? this.startTime : this.endTime
      let params = {}
      this.passby && (params.maxDate = new Date())
      mcDatePicker({ date: _defaultTime, ...params, format: 'YYYY-MM-DD' })
        .then(({ date, picker } = {}) => {
          if (
            index
              ? +date.replace(/-/gi, '') < +this.startTime.replace(/-/gi, '')
              : +date.replace(/-/gi, '') > +this.endTime.replace(/-/gi, '')
          ) {
            picker.reset()
            return mcToast({ msg: `开始时间不能大于结束时间` })
          }
          this[index === 0 ? 'startTime' : 'endTime'] = date
          this.$emit('time-section', this.startTime, this.endTime)
        })
        .catch()
    }
  }
}
</script>

<style lang="scss" scoped></style>
